import { render } from "./messageDialog.vue?vue&type=template&id=59768c3a&scoped=true"
import script from "./messageDialog.vue?vue&type=script&lang=js"
export * from "./messageDialog.vue?vue&type=script&lang=js"

import "./messageDialog.vue?vue&type=style&index=0&id=59768c3a&lang=less&scoped=true"
import "./messageDialog.vue?vue&type=style&index=1&id=59768c3a&lang=less"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59768c3a"]])

export default __exports__